import { useOrganizationStore } from "@/store/organization";

/**
 * @throws if there is no authenticated organization on the user.
 * @returns the non-null, non-undefined organization ID.
 */
export function useRequiredOrgId(): string {
  const organization = useOrganizationStore((s) => s.organization);

  // runtime‐check + type‐narrow
  if (!organization) {
    throw new Error(
      "Invariant: this operation requires a valid organization ID.",
    );
  }

  return organization.id;
}
